// IMPORTANT: Import cookie patcher FIRST, before any Stack SDK imports
import '@/utils/cookie-patcher';

import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App, AppContent } from '@/App';
import './styles/index.css';

// Hydration debugging
const root = document.getElementById('root');
if (root) {
  console.log('[Hydration Debug] Client-side HTML before hydration:');
  console.log(root.innerHTML);
  console.log('[Hydration Debug] Full HTML length:', root.innerHTML.length);
}

hydrateRoot(
  document.getElementById('root')!,
  <App
    router={
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    }
  />,
  {
    onRecoverableError: (error, errorInfo) => {
      console.error('[Hydration Error]', error, errorInfo);
    },
  }
);
